import React from 'react';
import Select from 'react-select';
import type { SelectOption } from '../Forms/types';

interface FormSelectProps {
  form: any;
  name: string;
  label?: string | React.ReactNode;
  placeholder?: string;
  options: SelectOption[];
  isMulti?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  form,
  name,
  label,
  placeholder,
  options,
  isMulti = false,
  required = false,
  disabled = false,
  className = '',
  isClearable = true,
  isSearchable = true,
}) => {
  return (
    <form.Field
      name={name}
      validators={{
        onBlur: ({ value }: any) => {
          if (required && (value === null || (Array.isArray(value) && value.length === 0))) {
            return 'This field is required';
          }
          return undefined;
        },

        onChange: ({ value }: any) => {
          if (required && (value === null || (Array.isArray(value) && value.length === 0))) {
            return 'This field is required';
          }
          return undefined;
        },
      }}
      children={(field: any) => {
        const hasError = field.state.meta.errors?.length > 0;
        const errorMessage = field.state.meta.errors?.[0];

        return (
          <div id={name} className={`${hasError ? 'form-element error' : 'form-element'} ${className}`}>
            {label && (
              <label htmlFor={name}>
               {`${label}${required ? '*' : ''}`}
              </label>
            )}
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              options={options}
              value={field.state.value}
              onChange={(value) => field.handleChange(value)}
              onBlur={field.handleBlur}
              placeholder={placeholder}
              isMulti={isMulti}
              isDisabled={disabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              name={name}
            />
            {hasError && (
              <div className="error-message">{errorMessage}</div>
            )}
          </div>
        );
      }}
    />
  );
};